import styled from 'styled-components';
import { COLORS, MEDIA_BREAKPOINT } from 'styles/variables';

export const Card = styled.div`
  position: relative;
  padding: 3.6rem 4.8rem;
  border: 1px solid ${COLORS.GREY_7};
  border-radius: 0.7rem;
  background-color: ${COLORS.WHITE};
  margin-bottom: 2.8rem;
`;

export const DayWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-left: -1rem;
`;

export const DayItem = styled.div`
  margin-left: 2rem;
  margin-bottom: 2rem;
  width: calc(100% / 7 - 2rem);
  @media ${MEDIA_BREAKPOINT.DESKTOP_S} {
    width: calc(100% / 4 - 2rem);
  }
  @media ${MEDIA_BREAKPOINT.DESKTOP_M} {
    width: calc(100% / 6 - 2rem);
  }
`;

export const TimeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 1rem;
  padding: 0 1.5rem;
`;

export const TimeItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 40%;

  label {
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1.9rem;
    letter-spacing: 0.32px;
    color: ${COLORS.BLACK_2};
  }

  .react-datepicker {
    font-size: 1.4rem;
    background-color: #fff;
    color: #000;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    display: inline-block;
    position: relative;
  }
  .react-datepicker-wrapper {
    display: inline-block;
    padding: 0;
    border: 0;
    width: 100%;

    input {
      font-size: 1.3rem;
      border-radius: 0.4rem;
      box-shadow: inset 0 2px 2px #e9e9e9;
      border: 1px solid #aeaeae;
      line-height: 1.6rem;
      padding: 0.6rem 1rem 0.5rem;
      text-align: center;
      width: 13.4rem;
      border-radius: 2rem;
    }
  }
  .react-datepicker__header {
    display: none;
  }
  .react-datepicker__input-container {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .react-datepicker__time-container {
    float: right;
    width: 10rem;
  }
  .react-datepicker-popper[data-placement^='bottom'] {
    padding-top: 1rem;
    z-index: 99;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list {
    list-style: none;
    margin: 0;
    height: calc(19.5rem + 0.85rem);
    overflow-y: scroll;
    padding-right: 0;
    padding-left: 0;
    width: 100%;
    box-sizing: content-box;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    height: 3rem;
    padding: 0.5rem 1rem;
    white-space: nowrap;
  }
`;
